import { Navigate } from "react-router-dom";
import { getToken, clearToken } from "./auth";
import { message } from "antd";

export default function ProtectedRoute({ children }) {
  const token = getToken();

  // Si no existe cookie o token inválido
  if (!token || token === "undefined" || token === "null" || token === "") {
    clearToken(); // elimina cualquier cookie inválida
    message.warning(
      "Su sesión ha expirado o no tiene acceso, por favor inicie sesión nuevamente."
    );
    return <Navigate to="/login" replace />;
  }

  // Si el token es válido, permite acceder
  return children;
}
